export default {"src":"/blogs/_next/static/media/whatsapp.c9828ecb.svg","height":71,"width":70,"blurWidth":0,"blurHeight":0};